export const bibleText = {
  en: {
    nt: 'New Testament', ot: 'Old Testament', selectBook: 'Select a book to begin', books: 'Books',
    loading: 'Loading…', parallel: '⇔ Parallel', noText: 'Text not available in this language.',
    chapters: 'CHAPTERS', verse: 'VERSE', text: 'Text:',
    outline: 'Outline', expandAll: 'Expand all', collapseAll: 'Collapse all',
    introFields: { author: 'Author', timeOfWriting: 'Time of Writing', placeOfWriting: 'Place of Writing', timePeriodCovered: 'Time Period Covered', recipient: 'Recipient' },
    subjectOf: (book) => `Subject of ${book}:`,
    prevChapter: 'Previous chapter', nextChapter: 'Next chapter',
    chapterLabel: (book, ch) => `${book} ${ch}`,
    scrubLabel: 'Chapter', scrubOpen: 'Choose a chapter', scrubHint: 'Hold and slide to choose a chapter',
    outlinePage: (book) => `${book} · Outline`, outlineShort: 'Outline',
  },
  es: {
    nt: 'Nuevo Testamento', ot: 'Antiguo Testamento', selectBook: 'Selecciona un libro', books: 'Libros',
    loading: 'Cargando…', parallel: '⇔ Paralelo', noText: 'Texto no disponible.',
    chapters: 'CAPÍTULOS', verse: 'VERSÍCULO', text: 'Texto:',
    outline: 'Bosquejo', expandAll: 'Expandir todo', collapseAll: 'Contraer todo',
    introFields: { author: 'Autor', timeOfWriting: 'Fecha de escritura', placeOfWriting: 'Lugar de escritura', timePeriodCovered: 'Período cubierto', recipient: 'Destinatarios' },
    subjectOf: (book) => `Tema de ${book}:`,
    prevChapter: 'Capítulo anterior', nextChapter: 'Capítulo siguiente',
    chapterLabel: (book, ch) => `${book} ${ch}`,
    scrubLabel: 'Capítulo', scrubOpen: 'Elegir un capítulo', scrubHint: 'Mantén pulsado y desliza para elegir un capítulo',
    outlinePage: (book) => `${book} · Bosquejo`, outlineShort: 'Bosquejo',
  },
  zh: {
    nt: '新約', ot: '舊約', selectBook: '請選擇一本書', books: '書卷',
    loading: '載入中…', parallel: '⇔ 對照', noText: '此語言暫無文字。',
    chapters: '章節選擇', verse: '節', text: '字體:',
    outline: '綱要', expandAll: '展開所有', collapseAll: '收合所有',
    introFields: { author: '著者', timeOfWriting: '著時', placeOfWriting: '著地', timePeriodCovered: '涵蓋時段', recipient: '受者' },
    subjectOf: (book) => `${book}的主題：`,
    prevChapter: '上一章', nextChapter: '下一章',
    chapterLabel: (book, ch) => `${book} 第${ch}章`,
    scrubLabel: '章', scrubOpen: '選擇章節', scrubHint: '按住並滑動以選擇章節',
    outlinePage: (book) => `${book} · 綱要`, outlineShort: '綱要',
  },
  sc: {
    nt: '新约', ot: '旧约', selectBook: '请选择一本书', books: '书卷',
    loading: '载入中…', parallel: '⇔ 对照', noText: '此语言暂无文字。',
    chapters: '章节选择', verse: '节', text: '字体:',
    outline: '纲要', expandAll: '展开所有', collapseAll: '收合所有',
    introFields: { author: '著者', timeOfWriting: '著时', placeOfWriting: '著地', timePeriodCovered: '涵盖时段', recipient: '受者' },
    subjectOf: (book) => `${book}的主题：`,
    prevChapter: '上一章', nextChapter: '下一章',
    chapterLabel: (book, ch) => `${book} 第${ch}章`,
    scrubLabel: '章', scrubOpen: '选择章节', scrubHint: '按住并滑动以选择章节',
    outlinePage: (book) => `${book} · 纲要`, outlineShort: '纲要',
  },
};
